"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateQuery = void 0;
const getStateQuery = () => {
    const slug = localStorage.getItem('re');
    const isCatalogGeneric = process.env.GENERIC_URL === slug;
    let state = '';
    if (isCatalogGeneric) {
        state = `&state=${localStorage.state}`;
    }
    return state;
};
exports.getStateQuery = getStateQuery;
